import React from 'react';
import { useMsal } from '@azure/msal-react';
import { OnboardingJourneyView } from '@onboarding/shared';
import { useImpersonationLink } from '../../services/hooks/useImpersonationLink';
import { usePrehireData } from '../../services/hooks/usePrehireData';
import { useOnboardingTasks } from '../../services/hooks/useOnboardingTasks';

/**
 * Candidate dashboard. Loads the signed-in candidate's data and hands it to the
 * shared OnboardingJourneyView, which is also used by the People Operations app.
 */
export const OnboardingJourney: React.FC = () => {
  const policiesLink = useImpersonationLink('/policies');
  const { accounts } = useMsal();
  const { data: prehireData, loading, error, refetch } = usePrehireData();
  const { tasks, updateTask, refetch: refetchTasks } = useOnboardingTasks();

  const firstName = accounts?.[0]?.name?.split(' ')?.[0] || '';

  return (
    <OnboardingJourneyView
      prehireData={prehireData}
      tasks={tasks}
      firstName={firstName}
      loading={loading}
      error={error}
      onRetry={refetch}
      updateTask={updateTask}
      onTaskUpdated={refetchTasks}
      policiesLink={policiesLink}
    />
  );
};
